<template>
  <div id="web-render">
    <template v-if="url != ''">
      <iframe :src="url" width="100%" sandbox="allow-forms allow-scripts allow-same-origin" height="100%"
        frameborder="0"></iframe>
    </template>
  </div>
</template>

<script>
import { heartBeat, } from "@/api/particulars";

export default {
  name: "",
  data() {
    return {
      originIP: "",
      url: "",
      port: "",
      path: "",
      did: "",
      dsn: "",
      hbTimer: null,
    };
  },
  methods: {
    heart() {
      if (this.hbTimer) {
        clearInterval(this.hbTimer)
        this.hbTimer = null
      } else {
        this.hbTimer = setInterval(() => {
          this.hbApi()
        }, 60000);
      }
    },
    hbApi() {
      heartBeat({
        deviceSN: this.dsn,
        did: this.did,
        ip: this.originIP
      }).then(res => {
        if (res.data.code !== 0) {
          this.$message.warning('意外断开连接!');
          this.unconnect()
        }
      }).catch(res => {
        this.$message.warning('意外断开连接!');
        this.unconnect()
      })
    },
    unconnect() {
      if (this.hbTimer !== null) {
        clearInterval(this.hbTimer);
        this.hbTimer = null;
      }
    }
  },
  mounted() {
    this.originIP = this.$route.query.ip;
    this.port = this.$route.query.port;
    this.path = this.$route.query.path;
    this.did = this.$route.query.id;
    this.dsn = this.$route.query.sn;
    this.url = `/deviceWeb/${this.originIP}/${this.port}${this.path}`
    setTimeout(() => {
      this.hbApi()
      this.heart()
    }, 3000);
  },
  beforeDestroy() {
    this.unconnect();
  },
};
</script>
<style scoped>
#web-render {
  width: 100vw;
  height: 100vh;
}
</style>